import React from 'react';
import Select from '../../../components/ui/Select';
import {
  supplierTermsOfPayment,
  supplierPaymentMethods,
  supplierDeliveryTerms,
  supplierModeOfDelivery,
  foreignSupplierGroups as supplierGroups,
  supplierCategories,
  commodityCodes
} from '../../../utils/questionnaireOptions';

const ForeignVendorQuestionnaire= ({ formData, updateFormData, errors }) => {
  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  return (
    <div className="space-y-8">
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-foreground mb-3">Vendor Questionnaire</h3>
        <p className="text-sm text-text-secondary">
          Please answer the following questions to complete the vendor approval process.
        </p>
      </div>

      {/* 2-Column Layout for better question distribution */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6">
        <Select
          label="1. Supplier Term of Payment"
          options={supplierTermsOfPayment}
          value={formData.supplierTermOfPayment}
          onChange={(value) => handleInputChange('supplierTermOfPayment', value)}
          error={errors.supplierTermOfPayment}
          required
          searchable
        />

        <Select
          label="2. Supplier Payment Method"
          options={supplierPaymentMethods}
          value={formData.supplierPaymentMethod}
          onChange={(value) => handleInputChange('supplierPaymentMethod', value)}
          error={errors.supplierPaymentMethod}
          required
        />

        <Select
          label="3. Supplier Delivery Terms"
          options={supplierDeliveryTerms}
          value={formData.supplierDeliveryTerms}
          onChange={(value) => handleInputChange('supplierDeliveryTerms', value)}
          error={errors.supplierDeliveryTerms}
          required
        />

        <Select
          label="4. Supplier Mode of Delivery"
          options={supplierModeOfDelivery}
          value={formData.supplierModeOfDelivery}
          onChange={(value) => handleInputChange('supplierModeOfDelivery', value)}
          error={errors.supplierModeOfDelivery}
          required
        />

        <Select
          label="5. Supplier Group"
          options={supplierGroups}
          value={formData.supplierGroup}
          onChange={(value) => handleInputChange('supplierGroup', value)}
          error={errors.supplierGroup}
          required
          searchable
        />

        <Select
          label="6. Supplier Category"
          options={supplierCategories}
          value={formData.supplierCategory}
          onChange={(value) => handleInputChange('supplierCategory', value)}
          error={errors.supplierCategory}
          required
          searchable
        />

        <Select
          label="7. Commodity Code"
          options={commodityCodes}
          value={formData.commodityCode}
          onChange={(value) => handleInputChange('commodityCode', value)}
          error={errors.commodityCode}
          required
          searchable
          className="lg:col-span-2"
        />
      </div>
    </div>
  );
};

export default ForeignVendorQuestionnaire; 